import React, { useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { CssBaseline, WithStyles, withStyles } from "@material-ui/core";
import { styles } from "./RegisterView.styles";
import * as UserRegistrationAction from "../../stores/user/UserRegistrationAction";
import { useTranslation } from "react-i18next";
import { CenteredContainer } from "../components/CenteredContainer/CenteredContainer";
import ToastStatusEnum from "../../constants/ToastStatusEnum";
import { useSnackbar } from "notistack";
import { useHistory } from "react-router-dom";
import { PageBanner } from "../components/PageBanner/PageBanner";
import { isUsedOpenAM } from "../../utilities/userUtils";
import { InternalRegistrationInfo } from "../components/InternalRegisterInfo/InternalRegisterInfo";
import { RegisterFormWithButton } from "./registration/RegisterFormWithButton";
import { selectVisibleCountries } from "../../selectors/countries/CountriesSelector";

export interface IRegisterViewProps extends WithStyles<typeof styles> {
}

const RegisterViewPure: React.FunctionComponent<IRegisterViewProps> = ({classes}) => {
    const {t} = useTranslation();
    const {enqueueSnackbar} = useSnackbar();
    const dispatch = useDispatch();
    const history = useHistory();

    const countries = useSelector(state => selectVisibleCountries(state));

    const [details, setDetails] = React.useState({
        email: "",
        firstName: "",
        lastName: "",
        jobPosition: "",
        phone: "",
        mobilePhone: "",
        company: "",
        tin: "",

        // honeypot
        website: "",

        addressLine1: "",
        addressLine2: "",
        postcode: "",
        city: "",
        country: "",

        deliveryAddressLine1: "",
        deliveryAddressLine2: "",
        deliveryPostcode: "",
        deliveryCity: "",
        deliveryCountry: "",

        howDidYouHearAboutDS: "",
        howDidYouHearAboutDSOther: ""
    });
    const [errors, setErrors] = React.useState([]);
    const [registerError, setRegisterError] = useState<string>("");
    const [anotherDeliveryAddress, setAnotherDeliveryAddress] = React.useState(false);

    const handleChange = (event, valid) => {
        const name = event.target.name;
        const value = event.target.value;

        setDetails({
            ...details,
            [name]: value
        });

        if (valid) {
            setErrors(errors.filter(e => e !== name));
        } else {
            setErrors(errors.concat(name));
        };
    };

    const handleCountry = (event) => {
        if (event.target.value !== "") {
            setDetails({
                ...details,
                [event.target.name]: event.target.value
            });
        }
    }

    const handleHowDidYouHearAboutUs = (radioValue, textValue) => {
        setDetails({
            ...details,
            howDidYouHearAboutDS: radioValue,
            howDidYouHearAboutDSOther: textValue
        });
    };


    const handleRegisterUser = event => {
        event.preventDefault();
        let sendDetails = details;
        if (anotherDeliveryAddress === false) {
            sendDetails.deliveryAddressLine1 = details.addressLine1;
            sendDetails.deliveryAddressLine2 = details.addressLine2;
            sendDetails.deliveryCity = details.city;
            sendDetails.deliveryPostcode = details.postcode;
            sendDetails.deliveryCountry = details.country;
        }
        if (details.website === "") {
            dispatch(UserRegistrationAction.registerUser(sendDetails))
                .then(() => {
                    enqueueSnackbar("User registered", {variant: ToastStatusEnum.Info});
                    setRegisterError("");
                    history.push("/register/success");
                })
                .catch(e => {
                    setRegisterError(e.message);
                });
        }
    };

    return <>
        <PageBanner title={t("register.header")} isPublic />
        <CenteredContainer>
            <CssBaseline />
            {isUsedOpenAM() ? (
                <InternalRegistrationInfo />
            ) : (
                <RegisterFormWithButton
                    type="register"
                    details={details}
                    registerError={registerError}
                    handleChange={handleChange}
                    handleCountry={handleCountry}
                    handleSubmit={handleRegisterUser}
                    handleHowDidYouHearAboutUs={handleHowDidYouHearAboutUs}
                    allCountries={countries}
                    errors={errors}
                    anotherDeliveryAddress={anotherDeliveryAddress}
                    setAnotherDeliveryAddress={setAnotherDeliveryAddress}
                />
            )}
        </CenteredContainer>
    </>;
};

export const RegisterView = withStyles(styles)(RegisterViewPure);
